export interface ShopResponse {
  id: number;
  shopID?: number;
  domain: string;
  instanceId: string;
  email?: string;
  token?: string;
  stepSetup?: number;
  currency?: string;
  getData?: boolean;
  status?: number;
  confirmUrl?: string;
  trialDay?: number;
  chargeId?: number;
  installedDate?: number;
  phone?: string;
  email2?: string;
  country?: string;
  planName?: string;
  disableBrandMark?: boolean;
  isGrantOrderPermission?: boolean;
  shopDescriptor?: ShopDescriptor;
  shopConfiguration?: ShopConfiguration;
  shopPricing: ShopPricing;
}
export interface ShopPricing {
  pricing: PricingScope;
  isBillingMonthy?: boolean;
  limitedDisplay?: number;
  numberOfDisplay?: number;
}

export enum PricingScope {
  Started,
  Pro
}
export interface ShopConfiguration {
  shopId: number;
  timezone: string;
}
export interface ShopDescriptor {
  id: string;
  shopOwner?: string;
  feedback?: string;
  feedbackStatus?: FeedbackStatus;
  shopId: number;
  site: SiteOfShopOptions;
  appInstance: AppInstanceOptions;
}

export interface SiteOfShopOptions {
  siteId: string;
  siteUrl: string;
  siteDisplayName: string;
  siteDescription: string;
}

export interface AppInstanceOptions {
  appName: string;
}

export enum FeedbackStatus {
  Good,
  Bad
}
